<template>
 <svg :style="style"  width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame">
<path id="Vector" d="M18.4855 4.85717C18.4855 4.85717 18.6569 16.1143 18.9997 16.2572C19.3426 16.3715 20.4855 17.4 25.1426 4.34288C25.314 3.91431 26.8283 3.25717 27.1997 4.85717C27.5712 6.45717 31.2855 20.3429 24.7426 27.0286C24.6855 27.0857 24.6283 27.1429 24.5426 27.1715C23.0855 27.9143 19.6569 27.2286 17.4855 25.0286C16.714 24.2572 13.2283 27.9429 10.8283 28.1429C9.62831 28.2286 5.37117 27.6286 3.65689 17.8C3.31403 15.8 3.19974 7.20002 4.68546 5.88574C4.97117 5.62859 6.31403 4.85717 7.7426 6.91431C9.17117 8.97145 12.514 15.9715 16.4283 16.7429C16.4283 16.7429 16.1712 7.42859 16.9426 5.34288C17.714 3.28574 18.3712 4.17145 18.4855 4.85717Z" fill="white"/>
</g>
</svg>






</template>

<script>
export default {
  name: 'icon-yxxgbfjb',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>